module.exports = __webpack_public_path__ + "img/step01_b_stand_basic_open_box-talaria.4966f96f.png";